import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { AssetAssignment } from './asset-assignment';
import { AssetShipmentAsset } from './asset-shipment-asset';


export class AssetShipment extends BaseEntity {

  assetShipmentCode : string	;
  branch            : Branch	;
  theDate	          : Date	  ;
  description	      : string	;
  progressLevel     : number	;
  role              : Role	  ;
  person            : Person  ;
  forecastDate      : Date    ;
  executionRole     : Role	  ;
  executionPerson   : Person	;
  executionDate     : Date    ;
  closingRole       : Role	  ;
  closingPerson     : Person  ;
  closingDate       : Date    ;

  assetAssignments    : AssetAssignment[];
  assetShipmentAssets : AssetShipmentAsset[];

  constructor() {
    super();

  }
}

	
